import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipTopBankListingComponent } from './payment-sip-top-bank-listing.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '../input/input.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';

@NgModule({
  declarations: [PaymentSipTopBankListingComponent],
  exports: [PaymentSipTopBankListingComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule
  ]
})
export class PaymentSipTopBankListingModule { }
